const preventSubmitOnEnter = (e) => {
  const keyCode = e.keyCode || e.which;
  if (keyCode === 13) {
    e.preventDefault();
  }
};

export default preventSubmitOnEnter;
